export const VENUE_TYPES = [
  'Conference Rooms',
  'Banquet halls',
  'Outdoor spaces',
  'Studios',
  'Lofts',
  'Hotels',
  'Cafés',
  'Restaurants',
  'Auditoriums'
];

export const AVATAR_URLS = {
  hosts: [
    'https://i.pravatar.cc/48?img=9',
    'https://i.pravatar.cc/48?img=12'
  ],
  network: Array.from({ length: 10 }, (_, i) => `https://i.pravatar.cc/40?img=${i + 19}`)
};

export const VENUE_DATA = {
  name: 'Kasa Cafe',
  address: '150 New Cavendish Street, London, W1W 6YJ',
  rating: 5.0,
  reviews: 248,
  image: '/Kasa-cafe.png'
};

export const EVENT_DATA = {
  title: 'Offline Reading Party 📚 | Pipes & Beans',
  hosts: ['Adrian Sobrado', 'Juliette Queval'],
  date: 'Thu, 31 Aug',
  time: '13:00 to 19:00 BST'
}; 
